import React from 'react';
import { getForgotPasswordURL } from 'src/dataLayer/env';
import TrackableLink from 'src/viewLayer/components/shared/TrackableLink';
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext';
import { useAppConfigContext } from 'src/viewLayer/components/contexts/AppConfigContext';
import { onForgotPasswordClicked } from 'src/viewLayer/helpers/safeNativeReporter';
import { t } from 'src/viewLayer/helpers/translations';

const WebForgotPasswordLink = ({ locale }) => (
  <TrackableLink
    className="ForgotPasswordLink"
    data-testid="forgot-password-link-web"
    trackingId="forgot_password_link"
    href={getForgotPasswordURL(locale)}
  >
    {t('password.links.forgot_password')}
  </TrackableLink>
);

const NativeMobileForgotPasswordLink = () => (
  <TrackableLink
    className="ForgotPasswordLink"
    data-testid="forgot-password-link-mobile"
    onClick={onForgotPasswordClicked}
    trackingId="forgot_password_link"
  >
    {t('password.links.forgot_password')}
  </TrackableLink>
);

const ForgotPasswordLink = () => {
  const { locale } = useRouteParamsContext();
  const { devicePath } = useAppConfigContext();
  return (
    devicePath === 'login-mobile' ? <NativeMobileForgotPasswordLink /> : <WebForgotPasswordLink locale={locale} />
  );
};

export default ForgotPasswordLink;
